module.exports = __webpack_public_path__ + "img/franc-sign.a76d781f.svg";